import { render } from "./c-table.vue?vue&type=template&id=25cc9c2b"
import script from "./c-table.vue?vue&type=script&lang=js"
export * from "./c-table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__